import React, { useContext } from 'react';
import { BG_STYLES, COLORS, COMMON_STYLES, TEXT_STYLES, TYPOGRAPHY, VARIANTS_STYLES } from "@dehaat/dds"
import { Pressable, StyleSheet, Text, View } from "react-native"
import { rnNavigation } from 'app/utils/appConfig';

import { ResponsiveContext } from 'app/context/ResponsiveUIContext';
import { isMobileDevice } from 'app/utils/common';
import { ROUTES } from 'app/routes/types';

const isDesktop = !isMobileDevice()
const NewRequestCTA = () => {
    const { mediaStyles } = useContext(ResponsiveContext);
    return (
        <View
            style={[
                BG_STYLES.bgWhite,
                {
                    shadowColor: '#000',
                    shadowOffset: { width: 0, height: -2 },
                    shadowOpacity: 0.1,
                    shadowRadius: 5,
                    elevation: 1,
                },
                mediaStyles({
                    desktopStyle: styles.container,
                    mobileStyle: COMMON_STYLES.p1
                })
            ]}>
            <Pressable
                style={styles.seeMoreBtn}
                onPress={() => rnNavigation({ name: ROUTES.NEW_REQUEST })}>
                <Text style={styles.seeMoreText}>New Request</Text>
            </Pressable>
        </View>
    )
}
const styles = StyleSheet.create({
    container: {
        ...COMMON_STYLES['p3/2'],
        ...COMMON_STYLES['mb3/2'],
        ...COMMON_STYLES.alignSelfCenter,
        ...COMMON_STYLES.fullWidth,
        maxWidth: 950,
    },
    seeMoreBtn: {
        ...COMMON_STYLES["mt3/4"],
        ...COMMON_STYLES.pr1,
        ...COMMON_STYLES["pl3/4"],
        ...BG_STYLES.bgPrimary100,
        ...COMMON_STYLES["br1/2"],
        ...COMMON_STYLES.alignItemsCenter,
        ...COMMON_STYLES.alignSelfCenter,
        ...COMMON_STYLES.fullWidth,
        paddingVertical: isDesktop ? 10 : 12,
    },
    seeMoreText: {
        ...VARIANTS_STYLES.SEMI_EMPHASIZED,
        ...TYPOGRAPHY.TEXT2,
        ...TEXT_STYLES.textWhite
    },
})
export default NewRequestCTA